export default "__VITE_ASSET__Dz2P2q8H__"